/**
 * RESPONSIBILITY: the Children's page questions band.
 */
import { Html } from '@framework/react';
import type { ChildrenFaqSection } from '@app/sections';

export function ChildrenFaq({ c }: { c: ChildrenFaqSection }) {
  const faq = c.faq ?? [];
  return (
    <section className="band band-tint">
      <div className="wrap">
        <div className="band-head"><h2>{c.faqHeading}</h2></div>
        <div className="faq">
          {faq.map((q, i) => (
            <details key={i} open={i === 0}>
              <summary>{q.question}</summary>
              {q.answerHtml && <Html className="md-body faq-answer">{q.answerHtml}</Html>}
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
